<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "EV Battery Condition" chart.
    </rb-callout>
</div>
<div id="ev-battery-condition-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Scatter plot showing the State of Health for capacity vs. the total distance travelled by the vehicle for your fleet (large black circles) and a reference fleet (gray small circles). The lines separate the vehicles into the three categories "below average", "average", and "above average" from bottom to top.
    </div>
</div>
